export default __webpack_public_path__ + "static/media/american-football.7d35480f.png";